import PersIOTMessageTypes from 'store/actionTypes/persIOTMessage'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  filter: {}
}

const persIOTMessage = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case PersIOTMessageTypes.GET_PERS_IOT_MESSAGE_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case PersIOTMessageTypes.UPDATE_FILTER_IOT_MESSAGE_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default persIOTMessage
